import { render, staticRenderFns } from "./DashboardActiveSurveysCard.vue?vue&type=template&id=117749ec&scoped=true"
import script from "./DashboardActiveSurveysCard.vue?vue&type=script&lang=js"
export * from "./DashboardActiveSurveysCard.vue?vue&type=script&lang=js"
import style0 from "./DashboardActiveSurveysCard.vue?vue&type=style&index=0&id=117749ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117749ec",
  null
  
)

export default component.exports